import script from "./CourtScheduleEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./CourtScheduleEdit.vue?vue&type=script&setup=true&lang=js"

import "./CourtScheduleEdit.vue?vue&type=style&index=0&id=63f86778&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63f86778"]])

export default __exports__